import React from 'react';
import './styles/index.css';
import './styles/main.css';
import Home from './components/home';
import { SmoothScrollProvider } from './vendor/SmoothScroll';
import { BrowserRouter as Router } from 'react-router-dom';
import { Helmet } from "react-helmet";

function App() {

  React.useEffect(() => {
    const el = document.getElementById('nizu-preloader');
    if (!el) return;

    const raf = window.requestAnimationFrame(() => {
      // Guard in case StrictMode removed it already
      const current = document.getElementById('nizu-preloader');
      if (!current) return;

      current.classList.add('nizu-preloader--hide');
      window.setTimeout(() => {
        const stillThere = document.getElementById('nizu-preloader');
        if (stillThere) stillThere.remove();
      }, 500);
    });

    return () => window.cancelAnimationFrame(raf);
  }, []);

  return (
    <SmoothScrollProvider lerp={0.1}>
    <div className=" Nizu-dev scrollbar">
      <Router>
        <Helmet>
          <title>Professional Full Stack Developer - Niyaz</title>
          <meta name="description" content="A Professional Full Stack Developer with creative ideas to implement for your Website and Web Application." />
          <meta name="keywords" content="Full Stack Developer, Dubai, Wordpress Developer, RPA, AI, Php, Python, React Js, Web developer, Web Application, Freelancer, Designer" />
          <meta property="og:title" content="Professional Full Stack Developer - Niyaz" />
          <meta property="og:description" content="A Professional Full Stack Developer with creative ideas to implement for your Website and Web Application." />
          <meta property="og:url" content="https://www.example.com" />
        </Helmet>
        <Home />
      </Router>
    </div>
    </SmoothScrollProvider>
  );
}

export default App;
